import React from 'react'
import { Button, Segment } from 'semantic-ui-react'
import logo from 'img/logo.png'
import '../../style.css'

class RolloverStart extends React.Component { 
  render() {
    return (
      <div className="ui container rollover">
        <Segment>
          <img id='rollLogo' src={logo} alt='logo'/>
          <h1 className='center green'>Welcome Back!</h1>
          <h3 className='grey'>According to your plans there may be some changes happening in your life This Year.  The “Roll Over Wizard” is here to remind of what those changes might be and allow you to confirm if your intentions are to stick to your plan or change your mind.</h3>
          <h3 className='green'>How it works?</h3>
          <div className='rollInstr'>For each up coming change we will ask you:</div>
          <div className='rollInstr'>Will (or in a few cases did) the change still happen?</div>
          <div className='rollInstr'>
            <Button.Group style={{marginRight: '5px'}}>
              <Button positive={true}>Yes</Button>
              <Button.Or />
              <Button>No</Button>
              <Button.Or />
              <Button>Undecided</Button>
            </Button.Group> Click “Yes” if you still plan to make the change, you can modify the amount here.
          </div>
          <div className='rollInstr'>
            <Button.Group style={{marginRight: '5px'}}>
              <Button>Yes</Button>
              <Button.Or />
              <Button negative={true}>No</Button>
              <Button.Or />
              <Button>Undecided</Button>
            </Button.Group> Click “No” if you no longer plan to make the change this year.
          </div>
          <div className='rollInstr'>
            <Button.Group style={{marginRight: '5px'}}>
              <Button>Yes</Button>
              <Button.Or />
              <Button>No</Button>
              <Button.Or />
              <Button color='orange'>Undecided</Button>
            </Button.Group> Click “Undecided” if you are not sure of your plans for this change. 
          </div>
          <div className='rollInstr'>It is that easy.</div>
          <h3 className='green'>You will also have a chance to quickly update all your account balances.</h3>
          <h3 className='green'>Don’t forget this may also be a good time to update other events that may be close a hand.</h3>
          <div style={{marginBottom: '60px'}}>
            <Button floated='right' className='button_green' content="Continue" onClick={this.props.onClick} />
          </div>
        </Segment>
      </div>
    )
  }
}

export default RolloverStart
